<template>
   <page-wrapper>
      <mep-logo/>
      <form-wrapper>
         <login-form/>
         <footer-links/>
      </form-wrapper>
   </page-wrapper>
</template>

<script>
import MepLogo from '../../atoms/Login/Logo';
import LoginForm from '../../organisms/Login/LoginForm';
import FormWrapper from '../../atoms/Login/FormWrapper';
import PageWrapper from '../../atoms/Login/PageWrapper';
import FooterLinks from '../../molecules/Login/FooterLinks';
import { hideLoading } from '../../../js/ui-helpers';

export default {
   name: 'login-page',
   components: {
      MepLogo,
      LoginForm,
      FormWrapper,
      FooterLinks,
      PageWrapper,
   },
   mounted()
   {
      setTimeout(() => {
         hideLoading();
      }, 100);
   },
}
</script>
